import { render, staticRenderFns } from "./BaiDangDiemDenForm.vue?vue&type=template&id=4307f0e3"
import script from "./BaiDangDiemDenForm.vue?vue&type=script&lang=js"
export * from "./BaiDangDiemDenForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports